const configuredBackend = process.env.REACT_APP_BACKEND_URL || "";
const browserOrigin = typeof window !== "undefined" ? window.location.origin : "";
const backendBase = configuredBackend || browserOrigin;

export const API_URL = backendBase.endsWith("/api")
  ? backendBase
  : `${backendBase.replace(/\/$/, "")}/api`;

export const apiUrl = (path) => `${API_URL.replace(/\/$/, "")}${path.startsWith("/") ? path : `/${path}`}`;

export const authHeaders = () => {
  const token = localStorage.getItem("tfu_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const formatRON = (n) =>
  new Intl.NumberFormat("ro-RO", { style: "currency", currency: "RON", minimumFractionDigits: 0 }).format(n || 0);
